import { Component } from '@angular/core';
import { BasePageComponent } from '../../../../shared/components/base-page/base-page.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-account-page',
  templateUrl: './account-page.component.html',
  styleUrls: ['./account-page.component.scss'],
  imports: [RouterModule, CommonModule, TranslateModule, FontAwesomeModule]
})
export class AccountPageComponent extends BasePageComponent{

  constructor() {
    super();
  }


}
